import Constant from '@/const';
import axios from 'axios';

const getQueueStatus = async () => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/pharmacy-queue/status`),
    );
    return response;
  } catch (error) {
    throw new Error(error);
  }
};

export default getQueueStatus;
